export const environment = {
    production: false,
    development: false,
    test: true,
    url: "https://test-pendeltag.stockholmstag.sj.se",
    loginRedirect: "https://test-pendeltag.stockholmstag.sj.se/signin-oidc",
    graphUrl: "https://graph.microsoft.com/v1.0",
    LineMapBaseUrl: "https://test-api.stockholmstag.sj.se/public/linemapapi/",
    trainOnTimeTrainsSuffix: "api/v2/linemap",
    trainOwnerSetting: "SLL",
    remarksGetAllSuffix: "api/remarks/GetAll?trainOwner=",
    remarkDeleteSuffix: "api/remarks/DeleteRemarkHard/",
    MessagesAPiBaseUrl: "https://test-api.stockholmstag.sj.se/public/messagesapi/",
    ActiveMessagesApiUrl: "api/Message/GetToTMessages",
    clientID: "21c703b8-a720-4c81-9379-02207efe7572",
    tenantID: "2146c4ae-6471-40a8-b821-2774c8057963",
    loginUrl: "https://login.microsoftonline.com/",
    adminGroups: ["4f08c6b7-e7b8-4fd5-b644-00f350f5f8c3"],
    lineMapScopes: "api://ca38f9f4-cc6b-4eb8-bfaf-6bf51445f871/access_as_user",
    messagesScopes: "api://cddfa479-5a1c-4c43-91fa-aaa4bd9ffbf0/access_as_user"
}
